import React from "react"
import Autosuggest from 'react-autosuggest'

var terms;

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0 ? [] : terms.filter(lang =>
    lang.toLowerCase().slice(0, inputLength) === inputValue
  );
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {suggestion}
  </div>
);


export default class SearchTermBar extends React.Component{
  constructor(props){
    super(props)

    terms = props.data.corpusTerms.terms.map(a => a.term);

    this.state = {
      value: '',
      suggestions: [],
      onClick: props.handleChange,
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onSuggestionSelected = (event, {suggestionValue}) => {
    this.state.onClick(suggestionValue);
  }



  render(){
    const { value, suggestions, onClick } = this.state;

   // Autosuggest will pass through all these props to the input.
   const inputProps = {
     placeholder: 'Search for a term',
     value,
     onChange: this.onChange
   };

    return(
	  <>
      <label for="search">
        Search for Terms:
	  </label>
        <Autosuggest
           suggestions={suggestions}
           onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
           onSuggestionsClearRequested={this.onSuggestionsClearRequested}
           getSuggestionValue={getSuggestionValue}
           renderSuggestion={renderSuggestion}
           onSuggestionSelected={this.onSuggestionSelected}
           inputProps={inputProps}
           onChange={onClick}
           style={{width:"65%"}}
           className="col-md-4"
		   name="search"
         />
		</>
    )
  }

}
